import clsx from "clsx";

export interface TabOption<T = string> {
  value: T;
  label: string;
  disabled?: boolean;
}

interface ButtonGroupProps<T = string> {
  options: TabOption<T>[];
  selected?: T;
  onSelect: (value: T) => void;
  hasError?: boolean;
  className?: string;
}

const ButtonGroup = <T extends string | number>({
  options,
  selected,
  onSelect,
  hasError,
  className,
}: ButtonGroupProps<T>): React.ReactElement => {
  return (
    <div
      className={clsx(
        className,
        "flex space-x-1 p-1 rounded-lg w-full",
        hasError ? "bg-red-50 border border-red-300" : "bg-gray-100"
      )}
    >
      {options.map((option) => (
        <button
          key={String(option.value)}
          type="button"
          onClick={() => onSelect(option.value)}
          disabled={option.disabled}
          className={clsx(
            "px-4 py-2 rounded-md text-sm font-medium transition-colors border flex-1",
            "disabled:opacity-50 disabled:cursor-not-allowed",
            selected === option.value
              ? "border-blue-600 text-blue-600 bg-white shadow-sm"
              : "border-transparent text-gray-700 hover:text-gray-900 hover:bg-gray-200 disabled:hover:bg-transparent disabled:hover:text-gray-700"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ButtonGroup;
